module.exports = __webpack_public_path__ + "static/img/lr.7c55dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/lr.png
// module id = m4iz
// module chunks = 18